module.exports = __webpack_public_path__ + "static/media/Dr. Sara Furqan.865d84eb.jpg";